export default __webpack_public_path__ + "static/media/add_shopping_cart.f6904ef5.svg";